import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { LIQUIDATION_DIFFERENCE_REASON_PATH } from '../../../../config/paths';
import {
  clearLiquidationDifferenceReason,
  getLiquidationDifferenceReason,
  putLiquidationDifferenceReason,
} from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import LiquidationDifferenceReasonForm from './LiquidationDifferenceReasonForm';

const EditLiquidationDifferenceReason = ({
  breadcrumbs,
  dispatchGetLiquidationDifferenceReason,
  dispatchClearLiquidationDifferenceReason,
  dispatchPutLiquidationDifferenceReason,
  match: {
    params: { id: liquidationDifferenceReasonId },
  },
  loading,
  liquidationDifferenceReason,
}) => {
  useLayoutEffect(() => {
    dispatchGetLiquidationDifferenceReason({ liquidationDifferenceReasonId });

    return () => dispatchClearLiquidationDifferenceReason();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPutLiquidationDifferenceReason(liquidationDifferenceReasonId, {
      ...formValues,
    });

  const generateInitialValues = ({
    name,
    description
  }) => ({
    name,
    description
  });

  let content;

  if (loading) content = <Loader />;
  else if (liquidationDifferenceReason.isEmpty())
    content = <NoDataResource returnPage={LIQUIDATION_DIFFERENCE_REASON_PATH} />;
  else
    content = (
      <LiquidationDifferenceReasonForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(liquidationDifferenceReason.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Discrepancia de Liquidación"
      subtitle="Editar discrepancia de liquidación"
      content={content}
    />
  );
};

EditLiquidationDifferenceReason.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearLiquidationDifferenceReason: PropTypes.func.isRequired,
  dispatchGetLiquidationDifferenceReason: PropTypes.func.isRequired,
  dispatchPutLiquidationDifferenceReason: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  liquidationDifferenceReason: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditLiquidationDifferenceReason.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearLiquidationDifferenceReason: clearLiquidationDifferenceReason,
  dispatchGetLiquidationDifferenceReason: getLiquidationDifferenceReason,
  dispatchPutLiquidationDifferenceReason: putLiquidationDifferenceReason,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Discrepancias de Liquidación',
      href: LIQUIDATION_DIFFERENCE_REASON_PATH,
    },
    {
      text: 'Ver',
      href: `${LIQUIDATION_DIFFERENCE_REASON_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  liquidationDifferenceReason: AccountingUnit.LiquidationDifferenceReason.getIn(['current', 'content']),
  loading: !AccountingUnit.LiquidationDifferenceReason.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditLiquidationDifferenceReason);
